module.exports = __webpack_public_path__ + "fonts/Arnhem-Normal.99a46f8.woff2";